module.exports = __webpack_public_path__ + "img/xp_icon_st02.png";